import React from 'react';
import Layout from '../../layout';






function ProjectDetails() {
  return (
   <Layout>
         <section class="page-header padding">
           <div class="overlay"></div>
            <div class="container">
               <div class="section-heading mt-40 text-center">
                    <h4 class="sub-heading">Project Details</h4>
                    <h2>The Burj <span>Khalifa Tower!</span></h2>
                    <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                </div>
            </div>
        </section>

        <section class="project-section-2 bd-bottom padding">
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="col-md-6 sm-padding">
                        <div class="project-img">
                            <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/project-1.jpg" alt="project" />
                        </div>
                    </div>
                    <div class="col-md-6 sm-padding">
                        <div class="project-info-box">
                            <h2>Project Details</h2>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction.</p>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="p-info">
                                        <h3>Date <span>January 08, 2018</span></h3>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="p-info">
                                        <h3>Client <span>DynamicLayers Company</span></h3>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="p-info">
                                        <h3>Project type <span>Contruction, Building</span></h3>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="p-info">
                                        <h3>Project Director <span>Jhon Castellon</span></h3>
                                    </div>
                                </div>
                            </div>
                            <div class="p-social">
                                <a href="#"><i class="fab fa-facebook-f"></i></a>
                                <a href="#"><i class="fab fa-instagram"></i></a>
                                <a href="#"><i class="fab fa-twitter"></i></a>
                                <a href="#"><i class="fab fa-pinterest"></i></a>
                                <a href="#"><i class="fab fa-fab fa-google-plus"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="project-section padding">
            <div class="container">
              <div class="section-heading text-center mb-40">
                <h2>Related Projects</h2>
              </div>
                <div class="project-items grid dl-lb-gallery row">
                    <div class="col-lg-4 col-md-6 padding-15 single-item architecture building">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/project-9.jpg" alt="project" />
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/project-9.jpg"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="#"><span>Architecture</span></a>
                                <a href="#"><h3>The Burj Khalifa</h3></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 padding-15 single-item construction building">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/project-8.jpg" alt="project" />
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/project-8.jpg"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="#"><span>Construction</span></a>
                                <a href="#"><h3>Shun Hing Square</h3></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 padding-15 single-item construction industrial">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/project-6.jpg" alt="project" />
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/project-6.jpg"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="#"><span>Building</span></a>
                                <a href="#"><h3>Central Park Tower</h3></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
   </Layout>
  );
}

export default ProjectDetails;